/* eslint-disable */
export default {
  ringtones: 'Sonneries',
  incomingRingtone: 'Sonnerie pour les appels entrants',
  outgoingRingtone: 'Sonnerie pour les appels sortants',
  play: 'Lire',
  stop: 'Arrêter',
  upload: 'Téléverser',
  reset: 'Réinitialiser',
  save: 'Enregistrer',
} as const;

// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"incomingRingtone"@#@ @source: @#@"Incoming Ringtone"@#@
// @key: @#@"outgoingRingtone"@#@ @source: @#@"Outgoing Ringtone"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"stop"@#@ @source: @#@"Stop"@#@
// @key: @#@"upload"@#@ @source: @#@"Upload"@#@
// @key: @#@"reset"@#@ @source: @#@"Reset"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
